import { usePlayerStore } from '@/store/usePlayerStore';
import { getActiveHls } from './useHls';
import { getActiveDashPlayer } from './useDash';

export function LiveButton() {
  const isLive = usePlayerStore((s) => s.isLive);
  const latency = usePlayerStore((s) => s.latency);

  if (!isLive) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    // Try HLS first, then dash.js.
    const hls = getActiveHls();
    if (hls) {
      const livePos = hls.liveSyncPosition;
      if (livePos != null) {
        const video = document.querySelector<HTMLVideoElement>('video');
        if (video) video.currentTime = livePos;
      }
      return;
    }
    const dash = getActiveDashPlayer();
    if (dash) {
      dash.seekToOriginalLive();
    }
  };

  const showLatency = latency > 3;

  return (
    <button
      onClick={handleClick}
      className="flex items-center gap-1 text-xs font-semibold uppercase tracking-wide text-red-500 hover:text-red-400 transition-colors px-1"
      title="Jump to live"
      aria-label="Jump to live"
    >
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" />
      </span>
      <span>LIVE</span>
      {showLatency && <span className="tabular-nums text-white/60">{latency}s</span>}
    </button>
  );
}
